import { Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { EditDialogInstance } from '../editDialog/editDialogService';
import { EditDialogComponent } from '../editDialog/editDialogComponent';
import { TaskInput } from '../../entities/task/taskInput';

@Component({
  selector: 'lib-task-create-dialog',
  templateUrl: './task-create-dialog.component.html',
  styleUrls: ['./task-create-dialog.component.scss']
})
export class TaskCreateDialogComponent implements EditDialogInstance, OnInit {

  readonly ref = inject(DynamicDialogRef);
  readonly config = inject(DynamicDialogConfig);

  readonly taskForm = new FormGroup({
    title: new FormControl<string | undefined>(undefined, Validators.required),
    description: new FormControl<string | undefined>(undefined),
    type: new FormControl<string | undefined>(undefined),
  });

  ngOnInit(): void {
    // Pre-fill type if provided via config
    if (this.config.data?.type) {
      this.taskForm.patchValue({
        type: this.config.data.type
      });
    }
  }

  onConfirm(editDialogComponent: EditDialogComponent<any>): void {
    const taskInput = new TaskInput();
    taskInput.title = this.taskForm.value.title;
    taskInput.description = this.taskForm.value.description;
    // taskInput.type = this.taskForm.value.type;
    this.ref.close(taskInput);
  }

  onReject(editDialogComponent: EditDialogComponent<any>): void {
    this.ref.close(false);
  }

  getEditForm(): FormGroup {
    return this.taskForm;
  }
}
